<template>
<!-- 交易数据 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :model="filters" class="findform">
        <el-form-item label="店铺订单号：" style="display:flex;width:30%">
          <el-input v-model="filters.vipCardName" placeholder="请输入店铺订单号" style="width:90%"/>
        </el-form-item>
        <el-form-item label="所属店铺：" style="display:flex;width:30%">
          <el-select v-model="filters.ssmdId" placeholder="请选择" ref="mySelect" filterable style="width:90%">
            <el-option v-for="(item,index) in ssmdOptions" :key="index" :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" style="display:flex;width:30%">
          <el-select v-model="filters.vipOrderStatusId" placeholder="请选择" ref="mySelect" style="width:90%">
            <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form class="findform">
        <el-form-item label="交易时间：" style="display:flex;width:30%">
          <el-date-picker type="daterange" v-model="filters.jysjTime" unlink-panels @change="changeTimeJysj" style="width:90%"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item label="所属城市：" style="display:flex;width:30%;">
          <el-cascader placeholder="请选择城市" filterable clearable style="width:90%"
          :options="options" v-model="filters.chengshi" @change="handleChange"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit" style="margin-right:10px;">查询</el-button>
        </el-form-item>
        <el-form-item> <el-button type="primary" @click="onExport">导出</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">店铺交易记录</p>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="店铺订单号" align="center">
          <template scope="scope">
            <span :title="scope.row.OrderNo" :label="scope.row.OrderNo" class="spanList">{{scope.row.OrderNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属店铺" align="center">
          <template scope="scope">
            <span :title="scope.row.BbName" :label="scope.row.BbName" class="spanList">{{scope.row.BbName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户来源" align="center">
          <template scope="scope">
            <span :title="scope.row.UserName" :label="scope.row.UserName" class="spanList">{{scope.row.UserName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户电话" align="center">
          <template scope="scope">
            <span :title="scope.row.UserPhone" :label="scope.row.UserPhone" class="spanList">{{scope.row.UserPhone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易时间" align="center">
          <template scope="scope">
            <span :title="scope.row.CTime" :label="scope.row.CTime" class="spanList">{{scope.row.CTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实付金额" align="center">
          <template scope="scope">
            <span :title="scope.row.Price" :label="scope.row.Price" class="spanList">￥{{scope.row.Price}}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台佣金" align="center">
          <template scope="scope">
            <span :title="scope.row.CommissionPrice" :label="scope.row.CommissionPrice" class="spanList">￥{{scope.row.CommissionPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家应得金额" align="center">
          <template scope="scope">
            <span :title="scope.row.BbPrice" :label="scope.row.BbPrice" class="spanList">￥{{scope.row.BbPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column label="垫付金额" align="center">
          <template scope="scope">
            <span class="spanList">￥{{scope.row.Othorpayprice}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="会员优惠" align="center">
          <template scope="scope">
            <span :title="scope.row.VipDiscountPrice" :label="scope.row.VipDiscountPrice" class="spanList">{{scope.row.VipDiscountPrice}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="订单状态" align="center">
          <template scope="scope">
            <span :title="scope.row.StatusName" :label="scope.row.StatusName" class="spanList">{{scope.row.StatusName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否已结算" align="center">
          <template scope="scope">
            <span :title="scope.row.IsSettlementName" :label="scope.row.IsSettlementName" class="spanList">{{scope.row.IsSettlementName}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" align="center" width="160px">
          <template scope="scope">
            <!-- <span v-if="scope.row.StatusName != '待支付' && scope.row.IsSettlement == 0" @click="showSettlement(scope.row.Id)" class="handle">
              <i class="el-icon-edit-outline"></i> 结算
            </span> -->
            <span @click="seeOrder(scope.row.Id, scope.row.StatusId)" class="handle"> <i class="el-icon-view"></i>查看 </span>
            <span @click="confirmShipment(scope.row.Id)" class="handle" v-show="scope.row.IsShowDeliver"> <i class="el-icon-truck"></i> 发货 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
      <!-- <div class="copywriting">
        <p> 平台佣金 </p>
        <p>1、会员用户消费：实付金额*会员所消费品牌平台抽佣比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
        <p>2、非会员用户消费：实付金额*固定佣金比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
      </div> -->
    </div>
  </div>

  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="dialog" :show-close= false>
    <template v-slot:title>
      <ul class="drawer_title">
        <li>订单详情</li>
        <li>{{formDetails.StatusName}}</li>
      </ul>
    </template>
    <div class="drawer_div">
      <ul class="drawer_ul">
        <li>
          <span class="watch_first">订单号：</span>
          <span>{{formDetails.OrderNo}}</span>
        </li>
        <li>
          <span class="watch_first">创建日期：</span>
          <span>{{formDetails.CTime}}</span>
        </li>
        <li>
          <span class="watch_first">交易类别：</span>
          <span>{{formDetails.BrandName}}</span>
        </li>
        <li>
          <span class="watch_first">付款店铺：</span>
          <span>{{formDetails.BbName}}</span>
        </li>
        <li>
          <span class="watch_first">商品总价：</span>
          <span>￥{{formDetails.TotalPrice}}</span>
        </li>
        <li>
          <span class="watch_first">导购员工：</span>
          <span>{{formDetails.GuidancePhone}}</span>
        </li>
        <li>
          <span class="watch_first">用户电话：</span>
          <span>{{formDetails.UserPhone}}</span>
        </li>
        <li>
          <span class="watch_first">款项类型：</span>
          <span>{{formDetails.PaymentTypeName}}</span>
        </li>
        <li>
          <span class="watch_first">优惠信息：</span>
          <span style="display: inline-table;margin-left:-40px;">
          <ul v-for="item in formDetails.CouponsInfoList" :key="item">
            <li>{{item}}</li>
          </ul>
          </span>
        </li>
        <li>
          <span class="watch_first">实付金额：</span>
          <span>￥{{formDetails.Price}}</span>
        </li>
        <li>
          <span class="watch_first">垫付金额：</span>
          <span>￥{{formDetails.Othorpayprice}}</span>
        </li>
        <li>
          <span class="watch_first">货款金额：</span>
          <span>{{formDetails.BbPrice}}</span>
        </li>
        <li>
          <span class="watch_first">返现金额：</span>
          <span>￥{{formDetails.ReturnPrice}}</span>
        </li>
        <li>
          <span class="watch_first">导购佣金：</span>
          <span>￥{{formDetails.GuidePrice}}</span>
        </li>
        <li>
          <span class="watch_first">纸质凭证：</span>
          <span v-for="itemImgUrl in formDetails.VipContractVoucherList" :key="itemImgUrl.VoucherUrl">
            <el-image :src="itemImgUrl.VoucherUrl" class="imgUrl" @click="handleClickItem" :preview-src-list="[itemImgUrl.VoucherUrl]"/>
          </span>
        </li>
        <li>
          <span class="watch_first">交易备注：</span>
          <span>{{formDetails.Remark}}</span>
        </li>
        <li v-show="formDetails.StatusId != 6">
          <span class="watch_first">退款说明：</span>
          <span>{{formDetails.RefundRemark}}</span>
        </li>
        <li v-show="formDetails.StatusId == 9">
          <span class="watch_first">退款失败说明：</span>
          <span>请使用资金管理员微信扫码登录https://pay.weixin.qq.com/（或登录微信“商家助手”小程序）查看账户可用余额大于等于本订单货款金额，如金额不足请先进行充值后再次发起退款申请；如账户可用金额大于等于本订单货款依然是退款失败或有其它疑问请联系400-157-7588。</span>
        </li>
      </ul>
      <!-- <ul class="drawer_ul">
        <li>
          <span class="watch_first">导购姓名：</span>
          <span>{{formDetails.GuidanceName}}</span>
        </li>
        <li>
          <span class="watch_first">导购电话：</span>
          <span>{{formDetails.GuidancePhone}}</span>
        </li>
      </ul> -->
      <div class="drawer_foot">
        <el-button type="info" @click="tuikuan(1)" v-show="formDetails.StatusId == 6">同意退款</el-button>
        <el-button type="primary" @click="tuikuan(0)" v-show="formDetails.StatusId == 6">拒绝退款</el-button>
        <el-button type="primary" @click="cxfqtk(1)" v-show="formDetails.StatusId == 9">重新发起退款</el-button>
        <el-button type="danger" @click="cancelForm">关 闭</el-button>
      </div>
    </div>
  </el-drawer>

  <!-- 发货提示-弹框 -->
  <el-dialog title="发货提示" :visible.sync="seeFhtx" :center="true" width="30%" append-to-body>
    <div style="text-align:center;padding-bottom: 20px;">
      <p style="font-size: 18px;">确定该订单商品已经被用户取走或已配送安装了吗？</p>
      <P>温馨提示：确定发货后，订单将在14天内自动确认收货；</P>
    </div>
    <div style="text-align:center">
      <el-button type="danger" @click="fixFh">确定</el-button>
      <el-button @click="seeFhtx = false">取消</el-button>
    </div>
  </el-dialog>

  <!-- 退款审核 -->
  <el-dialog title="退款审核" :visible.sync="seeTksh" :center="true" class="add_order_cancle" width="25%">
    <el-form>
      <el-form-item label="审核备注：" style="display:flex;">
        <el-input v-model="shenmark" placeholder="请输入审核备注" maxlength="100"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" @click="qdTksh()">确定</el-button>
      <el-button @click="seeTksh = false">取 消</el-button>
    </div>
  </el-dialog>
  <!-- 退款审核 end -->
  
  <!-- 退款提示-弹框 -->
  <el-dialog title="退款提示" :visible.sync="seeTktx" :center="true" width="25%" append-to-body>
    <div style="text-align:center;padding-bottom: 20px;">
      <p style="font-size: 18px;">确定重新发起退款吗？</p>
    </div>
    <div style="text-align:center">
      <el-button type="danger" @click="fixTk">确定</el-button>
      <el-button @click="seeTktx = false">取消</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getTradeRecordsListForPlatformByCondition, getTradeRecordOrderDetailById, getkind,
  getUpdateVIPTradeOrderPlatformIsSettlement } from "../../api/api";
import { userIdentity, provincegetcountys } from '../../api/newOss';
import { postShopOrderExportToExcel, putDeliver, putReviewRefund } from "../../api/comment";

export default {
  name: 'transactionsPlatform',
  mixins: [alertTrends],
  props: ["menuAction"],
  data() {
    return {
      show3: true,
      dialog: false, // 抽屉详情
      timer: null,
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      provinceId: 0,
      cityId: 0,
      tbdprovince: [],
      tbdcity: [],
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      ssmdOptions: [], // 所属店铺
      statusoptions: [], // 状态
      filters: {
        vipCardName: "", // 店铺订单号
        ssmdId: '', // 所属店铺
        vipOrderStatusId: 0, // 状态
        jysjTime: '', // 交易时间
        ksDate4: '', // 开始时间
        jsDate4: '', // 结束时间
        chengshi: "", // 所属城市
      },
      formDetails: [{
        StatusName: "", // 状态
        OrderNo: "", // 订单号
        CTime: "", // 创建日期
        BrandName: "", // 交易品牌
        BbName: "", // 付款店铺
        TotalPrice: "" , // 商品总价
        UserName: "", // 客户姓名
        UserPhone: "", // 客户电话
        CouponDiscountPrice: "", // 优惠券优惠金额
        Price: "", // 实付金额
        ReturnPrice: "", // 用户返现金额
        Remark: "", // 交易备注
        GuidanceName: "", // 导购姓名
        GuidancePhone: "", // 导购电话
        VipContractVoucherList: [] // 图片集合
        
      }],
      queryId: '',
      orderListId: '', // 订单id
      seeFhtx: false, // 发货提示-弹框
      seeTksh: false, // 退款审核
      shenmark: '', // 审核备注
      refundVal: '', // 退款标识
      seeTktx: false, // 退款提示-弹框
    }
  },
  methods: {
    // 选择时间查询
    changeTimeJysj() {
      if(this.filters.jysjTime+""=="null"){
        this.filters.jysjTime = ["",""]
      }
      this.ksDate4 = this.filters.jysjTime[0];
      this.jsDate4 = this.filters.jysjTime[1];
    },
    // 导出
    onExport() {
      let addParams = {
        userId: localStorage.Id, // 当前操作人id
        key: this.filters.vipCardName, // 店铺订单号
        bbid: this.filters.ssmdId, // 所属店铺id
        vipOrderStatusId: this.filters.vipOrderStatusId, // 状态
        beginTime: this.ksDate4, // 开始时间
        endTime: this.jsDate4, // 结束时间
        cityId: this.filters.chengshi, // 城市id
      };
      postShopOrderExportToExcel(addParams).then(data => {
        if (data.ResultCode == 1) {
          this.showAlert('导出成功', 'success');
          window.open(data.ResultObj);
        } else {
          this.showAlert('导出失败');
        }
      })
      
      // console.log("导出");
      // var addParams = [
      //   { name: "userId", value: localStorage.Id },
      //   { name: "key", value: this.filters.vipCardName },
      //   { name: "bbid", value: this.filters.ssmdId },
      //   { name: "vipOrderStatusId", value: this.filters.vipOrderStatusId },
      //   { name: "beginTime", value: this.ksDate4 },
      //   { name: "endTime", value: this.jsDate4 }
      // ];
      // var url = '/VIP/VIPTradeRecordManagement/ShopOrderExportToExcel';
      // this.downLoad(url, addParams);

    },
    // 确认发货
    confirmShipment(rowId) {
      this.orderListId = rowId; // 订单id
      this.seeFhtx = true; // 二次确认弹框
    },
    // 二次确定发货
    fixFh() {
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
      };
      putDeliver(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('发货成功', 'success');
          this.getorder();
          this.seeFhtx = false; // 二次确认弹框
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 同意退款 & 拒绝退款
    tuikuan(val) {
      this.refundVal = val; // 退款标识
      this.seeTksh = true; // 退款审核
      this.shenmark = '';
    },
    // 二次确定-退款审核
    qdTksh() {
      if(this.shenmark == "") {
        this.showAlert("请输入审核备注");
        return false;
      }
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
        refundRemark: this.shenmark, // 审核备注
        statusId: this.refundVal, // 审核状态  1=通过、0=不通过
      };
      putReviewRefund(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.getorder();
          this.seeTksh = false; // 退款审核
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 重新发起退款
    cxfqtk(val) {
      this.refundVal = val; // 退款标识
      this.seeTktx = true;
    },
    // 二次确定退款
    fixTk() {
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
        refundRemark: '', // 审核备注
        statusId: this.refundVal, // 审核状态  1=通过、0=不通过
      };
      putReviewRefund(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.getorder();
          this.seeTktx = false;
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },

    // 查询列表
    getorder() {
      let addParams = {
        userId: localStorage.Id, // 当前操作人id
        key: this.filters.vipCardName, // 店铺订单号
        bbid: this.filters.ssmdId, // 所属店铺id
        vipOrderStatusId: this.filters.vipOrderStatusId, // 状态
        // consumptionUserId: this.queryId, // consumptionUserId
        beginTime: this.ksDate4, // 开始时间
        endTime: this.jsDate4, // 结束时间
        provinceId: this.provinceId, // 订单所属省份id，默认为0，示例：1
        cityId: this.cityId, // 订单所属城市id，默认为0，示例：1
        pageIndex: this.pageIndex, // 分页数据 当前页码
        pageSize: 10, // 分页数据 每页显示条数
      };
      getTradeRecordsListForPlatformByCondition(addParams).then(data => {
          this.dataList = data.ResultObj;
          this.total = data.RowsCount;
        }).catch(err => {
          this.dataList = [];
        });
    },
    // 查看
    seeOrder(id, stateId) {
      this.orderListId = id; // 订单id
      this.dialog = true;
      var addParams = {
        tradeOrderId: id
      };
      getTradeRecordOrderDetailById(addParams).then(data => {
        this.formDetails = data.ResultObj;
      })
    },
    // 结算按钮
    showSettlement(id) {
      this.id = id;
      this.$swal({
        type:"warning",
        text:"是否确认结算?",
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((res)=>{
        if(res.value){
          this.makesure()
        }
      })
    },
    // 执行结算
    makesure() {
      var obj = {
        operatorId: localStorage.Id,
        tradeOrderId: this.id
      };
      getUpdateVIPTradeOrderPlatformIsSettlement(obj).then((data) => {
        if(data.ResultCode == 1){
          this.showAlert('操作成功', 'success');
          this.getorder();
        } else {
          this.showAlert(data.ResultMsg);
        }
      });
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.dialog = false;
      clearTimeout(this.timer);
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        provinceAndCityAndarea.unshift({ value: 0, label: '全国',});
        that.options = provinceAndCityAndarea;
      })
    },
    // 所属店铺
    handleStore() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        this.ssmdOptions = data.resultObj;
        // let newdata = data.resultObj;
        // let obj = {
        //   id: 0,
        //   name: "全部"
        // };
        // newdata.unshift(obj);
        // that.ssmdOptions = newdata;
      })
    },
    // 获取状态
    getorderstatus() {
      let that = this;
      var addParams = {
        tableName: "tBDVIPTradeStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(addParams).then(data => {
        let newdata = data.ResultObj;
        let obj = {
          Id: 0,
          Name: "全部"
        };
        newdata.unshift(obj);
        that.statusoptions = newdata;
      });
    },
    // 重置
    fnReset() {
      this.filters = {
        vipCardName: "", // 店铺订单号
        ssmdId: '', // 所属店铺
        vipOrderStatusId: 0, // 状态
        ksDate4: '',
        jsDate4: '',
        chengshi: "", // 所属城市
      },
      this.provinceId = 0;
      this.cityId = 0;
      this.queryId = '';
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getorder();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    let that = this;
    this.getprovince(); // 获取省
    this.handleStore(); // 获取所属店铺
    this.getorderstatus(); // 获取状态
    // 查询列表
    setTimeout(function() {
      that.getorder();
    }, 200);
    this.queryId = this.$route.query.consumptionUserId;
  }
  // activated() {
  //   let that = this;
  // }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.drawer_ul:first-child {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 5px;
}
.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}
.drawer_ul>li>span {
  font-size: 15px;
}
.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.watch_first {
  display: inline-block;
  color: #888;
  min-width: 90px;
  text-align: justify;
  text-align-last: justify;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.copywriting {
  width:80%;
  float:left;
  margin-top:15px;
  margin-left:20px;
}
</style>


// WEBPACK FOOTER //
// transactionsPlatform.vue?6025d185